import { useRequest } from "ahooks"
import { useRef } from "react"

export function usePollingWithMax(
	asyncFn: () => Promise<void>,
	{
		pollingInterval,
		maxCalls,
		ready,
		shouldBreak,
	}: {
		pollingInterval: number
		maxCalls: number
		ready?: boolean
		shouldBreak: () => boolean
	},
) {
	const callCountRef = useRef(0)

	const { run, cancel, loading } = useRequest(
		async () => {
			callCountRef.current += 1
			await asyncFn()
			if (shouldBreak() || callCountRef.current >= maxCalls) {
				cancel()
			}
		},
		{
			ready,
			pollingInterval,
			manual: true,
		},
	)

	// Optionally expose reset
	const reset = () => {
		callCountRef.current = 0
	}

	return { run, cancel, reset, loading }
}
